var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import "../types.js";
import { registerSystem } from "../ComponentRegistry.js";
import { S as SwapComponentsSchema } from "../../SwapComponents-882395c8.js";
import { C as ComponentCategory } from "../../enums-86f58524.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../global-33d5eebf.js";
import "../../utils/byteArray.js";
class SwapComponentsSystem {
  constructor() {
    __publicField(this, "type", "SwapComponents");
    __publicField(this, "category", ComponentCategory.CORE);
    __publicField(this, "schema", SwapComponentsSchema);
  }
  run(entity, gameModel) {
    const nextSwapSet = [];
    const nextSwapData = [];
    const swapComponents = gameModel.getTypedUnsafe(entity, SwapComponentsSchema);
    for (let i = 0; i < swapComponents.swapComponents.length; i++) {
      if (gameModel.hasComponent(entity, swapComponents.swapComponents[i])) {
        nextSwapData.push(gameModel.ejectComponent(entity, swapComponents.swapComponents[i]));
      }
    }
    for (let i = 0; i < swapComponents.swapData.length; i++) {
      gameModel.addComponent(entity, swapComponents.swapData[i].type, swapComponents.swapData[i].data);
      nextSwapSet.push(swapComponents.swapData[i].type);
    }
    swapComponents.swapComponents = nextSwapSet;
    swapComponents.swapData = nextSwapData;
    swapComponents.swapped = !swapComponents.swapped;
  }
}
registerSystem(SwapComponentsSystem);
export {
  SwapComponentsSystem
};
//# sourceMappingURL=SwapComponents.js.map
